import React, { useState, useEffect } from 'react';
import ItemYORP from './ItemYORP'
import Alert from './Alert'
import { useParams,  } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router';
import {FiPlusCircle, FiCheckCircle, FiXCircle} from "react-icons/fi"


import { db, auth } from '../functions/firebaseFunctions';
const EditServiceScreen = (props) => {

  const [uid, setUid] = useState(null)
  const { serviceId, priceId } =  useParams()
  const [sel, select] = useState('Decorator');
  const [price, setPrice] = useState(undefined);
  const [changes, setChanges] = useState(false);
  const navigateTo = useNavigate();
  // console.log('price:', price)

  const [dj, setDJ] = useState(null);
  const [singer, setSinger] = useState(null)
  const [band, setBand] = useState(null)
  const [rap, setRap] = useState(null)
  const [mus, setMus] = useState(null)
  const [decorator, setDecorator] = useState(null)
  const [florist, setFlorist] = useState(null)
  const [allservice, setallservice] = useState(null)

  const [Err, setErr] = useState(null);

  const [alert1, setAlert1] = useState(false);

  const [fb, setFB] = useState(true)


  useEffect(() => {
    var UID = auth.currentUser?.uid
    setUid(UID)
    if (UID) {
      db.collection("services").where("uid", "==", auth.currentUser?.uid)
        .onSnapshot((querySnapshot) => {
          var services = [];
          querySnapshot.forEach((doc) => {
            services.push(doc.data());
          });
          setallservice(services)

        })
    }
  }, [uid, mus])
  if (fb) {
    if (serviceId == 'new') {

      db.collection("services").where("uid", "==", auth.currentUser?.uid)
        .onSnapshot((querySnapshot) => {
          var services = [];
          querySnapshot.forEach((doc) => {
            services.push(doc.data());

          });
          setallservice(services)

          services[0]?.services?.map((data, i) => {

            if (data?.servicetype === "Musician") {
              setMus(data?.servicetype)
            }
            else if (data?.servicetype == "Singer") {
              setSinger(data?.servicetype)
            }
            else if (data?.servicetype == "Band") {
              setBand(data?.servicetype)
            }
            else if (data?.servicetype == "Rapper") {
              setRap(data?.servicetype)
            }
            else if (data?.servicetype == "DJ") {
              setDJ(data?.servicetype)
            }
            else if (data?.servicetype == "Decorator") {
              setDecorator(data?.servicetype)
            }
            else if (data?.servicetype == "Florist") {
              setFlorist(data?.servicetype)
            }
          })
        });

    } else {
      setPrice(priceId.toString())
    }
    setFB(false);
  }
  const priceIn = async event => {
    event.preventDefault();
    // console.log(changes)
    const priceInput = document.querySelector('#price');
    const price = priceInput.value;
    setPrice(price);
    setChanges(true);
    // console.log('price:', price, changes)
    var services = [];
    if (serviceId == 'new' && price && sel) {
      var obj = {
        price: price,
        servicetype: sel
      };
      services.push(obj);
      if (allservice.length === 0) {
        db.collection('services').doc(uid).set({
          services,
          uid
        })
        .then(() => {
          // navigation.goBack()
        })
        .catch((error) => setErr(error));
      } else {
        // console.log('allservice', allservice, 'allservice[0]', allservice[0], 'services', services);
        var updatedServices = allservice[0].services.concat(services);
        db.collection("services").doc(uid).update({
          services: updatedServices,
          uid,
        })
        .then(() => {
          navigateTo('/Profile/dashboard');
          setErr(null);
        })
        .catch((error) => setErr(error));
      }
    } else if (serviceId != 'new') {
      var updatedservice = [];
      var servicetype = serviceId;
      updatedservice.push({ servicetype, price })
      var services = allservice[0].services.filter((data, i) => data.servicetype != updatedservice[0].servicetype);
      services.push(updatedservice[0]);
      db.collection('services').doc(uid).set({
        services,
        uid: auth.currentUser?.uid,
      })
      .then(() => {
        setErr(null);
        navigateTo('/Profile/dashboard');
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
      setErr(null);
    } else {
      if (!price) { setErr({ code: 'NoPrice', message: 'Set the price for this service' }) }
      if (serviceId == 'new' && !sel) { setErr({ code: 'NoSel', message: 'Select the type of service' }) }
    }
    setChanges(false);
  }

  return (
    <div className='EventScreen'>
      {/* <div style={{ height: 2, width: "100%" }} /> */}
      {alert1 && <Alert title="Are you sure?"
        comment="Delete Service"
        setAlert={setAlert1}
        options={[
          { text: "No", style: "cancel" },
          {
            text: `Delete`, onClick: () => {

              db.collection("services").doc(auth.currentUser?.uid)
                .get().then((doc) => {

                  var services = doc.data().services.filter((data1, i) => data1.servicetype != serviceId)

                  db.collection("services").doc(auth.currentUser?.uid).set({
                    services
                  }, { merge: true })
                    .then(() => {
                      console.log("Document successfully written!");
                      navigateTo('/Profile/dashboard');
                    })
                    .catch((error) => {
                      console.error("Error writing document: ", error);
                    });
                });
            }, style: "destructive"
          },
        ]}
      />}
      <div style={{ display: 'flex', maxWidth: 500, alignSelf: 'center', width: "100%",  flexDirection: 'column' }}>
        {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
        <h1 style={{ color: 'white', alignSelf: 'center', marginTop: 10 }}>{serviceId == 'new' ? 'New Service' : serviceId}</h1>
        {serviceId == 'new' && <React.Fragment>
          <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
          <div className='centered' style={{ color: 'white', alignSelf: 'center', paddingBlock: 5, width: '100%'}}>
            <p style={{marginBlockEnd: 10, textAlign: 'center'}}>Select type of service: </p>
            <div className='EditEventButtons'>
              {!decorator && <ItemYORP title={'Decorator'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Decorator')
                }} />}
              {!florist && <ItemYORP title={'Florist'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Florist')
                }} />}
              {!dj && <ItemYORP title={'DJ'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('DJ')
                }} />
              }
              {!singer && <ItemYORP title={'Singer'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Singer')
                }} />}
              {!band && <ItemYORP title={'Band'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Band')
                }} />}
              {!rap && <ItemYORP title={'Rapper'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Rapper')
                }} />}
              {!mus && <ItemYORP title={'Musician'}
                sel={sel}
                onClick={() => {
                  setChanges(true)
                  select('Musician')
                }} />}

            </div>
          </div>
        </React.Fragment>}
        <div style={{ flexDirection: 'row', width: "100%" }}>
          <form onSubmit={priceIn}  style={{width: '100%', padding: 5, display: 'flex', flexDirection: 'column'}}>
          <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            <label htmlFor="price" className="label">
              Price per hour: $ 
              <input 
                style={{marginInlineStart: 5}}
                name='price'
                id='price'
                type='number'
                // style={{ paddingVertical: 0 }}
                // autocompletetype="off"
                placeholder= {priceId !== 'undefined' ? priceId : "Enter Price"}
              />
            </label>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
              <button 
                style={{
                  color: "var(--wht)",
                  alignSelf: 'center',
                  borderWidth: 0,
                  justifyContent: 'center',
                  alignContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifySelf: 'center',
                  // marginBlockStart: 10,
                }}
                color="white"
                type='submit'
              >
                {serviceId == 'new' ? 'Create Service' : 'Save Changes'}{serviceId === 'new' ? <FiPlusCircle style={{marginInline: 5,}} className='BrowseButton'/> : <FiCheckCircle style={{marginInline: 5,}} className='BrowseButton'/>}
              </button>
              {serviceId != 'new' && 
                <button
                  style={{color: 'var(--red)',  alignSelf: 'center', borderWidth: 0}}
                  onClick={() => { setAlert1(true) }}
                >
                  Delete Service <FiXCircle />
                </button>
              }
            </div>
        </form>
      </div>
      </div>
    </div>
  )
}
export default EditServiceScreen